module.exports = __webpack_public_path__ + "img/w-billable-rate.4bcc4573.svg";